(function () {
  const MIXA_HANDLES = [
    "mixa-niacinamide-la-creme-correction-eclat-visage-corps-mains-400ml",
    "mixa-creme-panthenol-confort-400ml",
    "mixa-creme-cica-reparation-reparatrice-lissante-400ml",
    "mixa-creme-ceramide-protection-400ml",
    "mixa-la-creme-fraiche-et-fondante-multi-usage-a-l-acide-hyaluronique-400ml",
    "mixa-creme-shea-reparatrice-pot-400ml",
    "mixa-creme-nutritive-satinante-peaux-metissees-pot-400ml"
  ];

  const GIFTS = {
    SAC: 47133827301551,
    MUG: 47133828120751,
    SERV: 47133827465391
  };

  const STORAGE_KEY = "bm_mixa_winner_code";

  let checking = false;
  let checkoutInProgress = false;
  let checkTimer = null;

  function saveCodeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("bm_win");

    if (code) {
      localStorage.setItem(STORAGE_KEY, code.toUpperCase());
    }
  }

  function getGiftVariantFromCode() {
    const code = localStorage.getItem(STORAGE_KEY);

    if (!code) return null;

    if (code === "SAC" || code.startsWith("SAC-")) {
      return GIFTS.SAC;
    }

    if (code === "MUG" || code.startsWith("MUG-")) {
      return GIFTS.MUG;
    }

    if (code === "SERV" || code.startsWith("SERV-")) {
      return GIFTS.SERV;
    }

    return null;
  }

  async function cartRequest(url, options) {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "Mixa cart request failed: " +
        response.status +
        " " +
        response.statusText
      );
    }

    return response;
  }

  async function getCart() {
    const response = await cartRequest("/cart.js", {
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    return response.json();
  }

  async function changeLine(key, quantity) {
    return cartRequest("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });
  }

  async function addGift(variantId) {
    return cartRequest("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          "_Offre": "Cadeau gagné via le jeu Mixa"
        }
      })
    });
  }

  function scheduleMixaCheck(delay) {
    if (checkoutInProgress) return;

    clearTimeout(checkTimer);

    checkTimer = setTimeout(function () {
      checkMixaGift();
    }, delay || 700);
  }

  async function checkMixaGift() {
    if (checking) return false;

    checking = true;
    let cartChanged = false;

    try {
      const cart = await getCart();
      const giftVariantId = getGiftVariantFromCode();
      const allGiftIds = Object.values(GIFTS);

      const hasMixa = cart.items.some(function (item) {
        return (
          item.url &&
          MIXA_HANDLES.some(function (handle) {
            return item.url.includes(handle);
          })
        );
      });

      /*
       * Supprimer les cadeaux Mixa incorrects,
       * non éligibles ou en quantité supérieure à 1.
       */
      for (const item of cart.items) {
        if (!allGiftIds.includes(Number(item.variant_id))) {
          continue;
        }

        const mustRemove =
          !giftVariantId ||
          !hasMixa ||
          Number(item.variant_id) !== Number(giftVariantId);

        if (mustRemove) {
          await changeLine(item.key, 0);
          cartChanged = true;
          continue;
        }

        if (item.quantity !== 1) {
          await changeLine(item.key, 1);
          cartChanged = true;
        }
      }

      /*
       * Relire le panier seulement si une suppression
       * ou une correction vient d'être effectuée.
       */
      const updatedCart = cartChanged ? await getCart() : cart;

      if (giftVariantId && hasMixa) {
        const hasCorrectGift = updatedCart.items.some(function (item) {
          return Number(item.variant_id) === Number(giftVariantId);
        });

        if (!hasCorrectGift) {
          await addGift(giftVariantId);
          cartChanged = true;
        }
      }

      return cartChanged;

    } catch (error) {
      console.error("BM Mixa gift error:", error);
      return false;

    } finally {
      checking = false;
    }
  }

  function isCheckoutButton(element) {
    if (!(element instanceof Element)) return false;

    const control = element.closest(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
    );

    return Boolean(control);
  }

  async function handleCheckout(event) {
    if (!isCheckoutButton(event.target)) return;

    /*
     * Aucun code gagnant :
     * ne pas toucher au checkout.
     */
    if (!getGiftVariantFromCode()) return;

    if (checkoutInProgress) {
      event.preventDefault();
      return;
    }

    checkoutInProgress = true;

    event.preventDefault();
    event.stopPropagation();

    clearTimeout(checkTimer);

    try {
      /*
       * Maximum 2,5 secondes d'attente.
       * Même en cas de problème réseau, le client
       * sera ensuite envoyé vers le checkout.
       */
      await Promise.race([
        checkMixaGift(),
        new Promise(function (resolve) {
          setTimeout(resolve, 2500);
        })
      ]);

    } catch (error) {
      console.error("BM Mixa checkout check error:", error);

    } finally {
      window.location.assign("/checkout");
    }
  }

  saveCodeFromUrl();

  document.addEventListener("DOMContentLoaded", function () {
    scheduleMixaCheck(800);
  });

  document.addEventListener("cart:updated", function () {
    scheduleMixaCheck(700);
  });

  document.addEventListener("ajaxCart:updated", function () {
    scheduleMixaCheck(700);
  });

  document.addEventListener("click", handleCheckout, true);

  window.addEventListener("pageshow", function () {
    scheduleMixaCheck(800);
  });
})();